module.exports = __webpack_public_path__ + "logo-white.e8bc319fa495ea115ca7762484c07547.svg";